<template>
    <div class="person">
        <div class="condition">
            <queryCondition ref="query" :list="queryList" :value="conditionData" labelWidth="120px" :search="selectData" :reset="reset"></queryCondition>
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                <el-table-column prop="aliPayAccount" label="支付宝账号" align="center"></el-table-column>
                <el-table-column prop="realName" label="真实姓名" align="center"></el-table-column>
                <el-table-column prop="nickName" label="昵称" align="center"></el-table-column>
                <el-table-column prop="phone" label="手机号码" align="center"></el-table-column>
                
                <el-table-column prop="money" label="提现金额" align="center"></el-table-column>
                <el-table-column prop="cashState" label="支付状态" align="center">
                    <template slot-scope="scope" >
                        <span :style="scope.row.isExceed&&scope.row.cashState == 1?'color:red':''">
                            {{scope.row.cashState == 1?'已提交':''}}
                            {{scope.row.cashState == 2?'提现完成':''}}
                            {{scope.row.cashState == -1?'提现失败':''}}
                        </span>
                        
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="reason" label="原因" align="center"></el-table-column> -->
                <el-table-column prop="creationTime" label="创建时间" align="center" width="180px"></el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="100px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="updateTip(scope.row)">编辑</el-button>
                </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="conditionData.current"
                    :page-size="conditionData.size">
                </el-pagination>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDialog" title="新增" width="500px">
            <forms ref="formListAdd" :list="formList" :value="formData" :rules="formRules" :btns="formAddBtns" labelWidth="120px"></forms>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="isUpdateDialog" title="编辑" width="500px">
            <forms ref="formListEdit" :list="formList" :value="formData" :rules="formRules" :btns="formEditBtns" labelWidth="120px"></forms>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isEditDialog" :title="'编辑用户-'+username" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        用户昵称:
                    </div>
                    <div class="valuet">
                        
                        <el-select v-model="editData.cashState" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in cashStateList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
               
                <div class="btns" style="margin-top:20px">
                    <el-button type="primary" icon="el-icon-edit" @click="editDataFun()">确认</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
import {wtlxList,isNewList} from '../../../assets/selectList/index'
import {parseTimeS} from '../../../utils/index'
export default {
    name: 'person',
    components:{
        queryCondition,
        forms
    },
    watch: {
    },
    data () {
        return {
            isAddDialog:false,
            isUpdateDialog:false,

            totalCount:0,
            tableData:[],

            conditionData:{
                phone:'',
                aliPayAccount:'',
                realName:'',
                cashState:'1',
                current:1,
                size:10,
            },
            queryList:[
                {type: "input",label: "手机号:",name: "phone",},
                {type: "input",label: "支付包账号:",name: "aliPayAccount",},
                {type: "input",label: "真实姓名:",name: "realName",},
                {type: "select",label: "支付状态:",name: "cashState",options:[{
                    label:'已提交',
                    value:'1',
                },{
                    label:'提现完成',
                    value:'2',
                },{
                    label:'提现失败',
                    value:'-1',
                }]},
            ],
           cashStateList: [{
                label:'已提交',
                value:'1',
            },{
                label:'提现完成',
                value:'2',
            },{
                label:'提现失败',
                value:'-1',
            }],
            formData:{
                Name:'',
                Type:'',
                UnderwritingAgency:'',
                IsNew:'',
            },
            formList:[
                {type: "input",label: "委托主体名称:",name: "Name",},
                {type: "select",label: "委托主体类型:",name: "Type",options:wtlxList},
                {type: "input",label: "承保机构:",name: "UnderwritingAgency",},
                {type: "select",label: "是否新来源:",name: "IsNew",options:isNewList},
            ],
            // 提交规则
            formRules:{
                Name: [{ required: true, message: '请填写委托主体名称', trigger: 'blur' }],
                Type: [{ required: true, message: '请填写委托主体类型', trigger: 'change' }],
                UnderwritingAgency: [{ required: true, message: '请填写承保机构', trigger: 'blur' }],
                IsNew: [{ required: true, message: '请填写是否新来源', trigger: 'change' }],
            },
            formAddBtns:[
                {name:'确认新增',icon:'el-icon-circle-plus',type:'success',handleClick:this.add},
                {name:'关闭',icon:'el-icon-error',type:'warning',handleClick:this.close}
            ],
            formEditBtns:[
                {name:'确认编辑',icon:'el-icon-edit',type:'success',handleClick:this.edit},
                {name:'关闭',icon:'el-icon-error',type:'warning',handleClick:this.close}
            ],

            isEditDialog:false,
            editData:{
                
            },
            username:'',
        }
    },
    created(){
    },
    mounted(){
        setTimeout(() => {
            this.loadingData();
        }, 300)
    },
    methods:{
        updateTip(row){
            this.editData = row;
            this.isEditDialog = true;
            this.username = row.nickName;
        },
        // table表头样式
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        // 加载table数据
        async loadingData() {
            let res  = await api.AdminCashCashQuery(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.records;
            this.totalCount = res.data.data.total;
          
            console.log(this.tableData);
        },
        getDiff(fromTime) {
            /*
            * a1,开始时间；
            * a2,结束时间
            * */
            //时间转化；
            var a1 = new Date(fromTime);
            var a2 = new Date();

            //判断是否时间选择错误;
            if (a1 > a2) {
                alert("结束时间不能小于开始时间!");
                return false;
            }

            //判断时间差;
            var total = (a2.getTime() - a1.getTime()) / 1000;//相差的秒数;
            var endTime = parseInt(total / ( 60 * 60));//计算是否超过24小时;
            console.log(endTime);
            if (endTime >= 24) {
                return true;
            }
        },
        // 查询
        selectData(){
            this.conditionData.current = 1;
            this.loadingData();
        },
        // 重置查询
        reset(){
            this.conditionData = {
                phone:'',
                aliPayAccount:'',
                realName:'',
                cashState:'1',
                current:1,
                size:10,
            },
            this.loadingData();
        },
        // 切换页面
        handleCurrentChange(page){
            this.conditionData.current = page;
            this.loadingData();
        },
        // 切换页面条数
        handleSizeChange(size){
            this.conditionData.current = 1;
            this.conditionData.size = size;
            this.loadingData();
        },
        // 新增弹窗
        showAddDialog(e){
            this.isAddDialog = true;
        },
        // 新增方法
        async add(){
            let flag = this.$refs["formListAdd"].validateForm();
            if(!flag){
                return;
            }
            let res  = await api.InsuranceCompanyAdd(this.formData);
            if(res.data.code == '200') {
                this.$message({
                    message: '添加成功',
                    type: 'success'
                });
                this.$refs["formListAdd"].resetFields();
                this.loadingData();
            }
        },
        isUpdateDialogShow(row){
            console.log(row);
            this.isUpdateDialog = true;
            this.formData = {
                id:row.id,
                Name:row.name,
                Type:row.type,
                UnderwritingAgency:row.underwritingAgency,
                IsNew:row.isNew,
            }
        },
        // 编辑方法
        async edit(){
            let flag = this.$refs["formListEdit"].validateForm();
            if(!flag){
                return;
            }
            let res  = await api.InsuranceCompanyEdit(this.formData);
            if(res.data.code == '200') {
                this.$message({
                    message: '编辑成功',
                    type: 'success'
                });
                this.$refs["formListEdit"].resetFields();
                this.isUpdateDialog = false;
                this.loadingData();
            }
        },
        // 关闭新增和编辑的弹框
        close(){
            if(this.isAddDialog){
                this.isAddDialog = false
            }else if(this.isUpdateDialog){
                this.isUpdateDialog = false
                this.$refs["formListEdit"].resetFields();
            }
        },
        // 删除提示
        deleteRowTip(row){
            this.$confirm('将删除委托主体——'+row.name+', 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteRow(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        // 删除方法
        async deleteRow(row){
            let res  = await api.InsuranceCompanyDel({id:row.id});
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
            }
        },
        async editDataFun(){
            let res  = await api.AdminCashUpdateCashState({
                id:this.editData.id,
                cashState:this.editData.cashState,
            });
            if(res.data.code == '200') {
                this.$message({
                    message: '编辑成功',
                    type: 'success'
                });
                this.isEditDialog = false
                this.loadingData();
            }
        }
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .dialog{
        .item{
            display: flex;
            align-items: center;
            .label{
                width: 120px;
            }
        }
    }
</style>
